import { PropertiesPanelControl, PropertiesPanelLabel, PropertiesPanelProperty } from './propertiesPanelProperty';
import React from 'react';
import { Icon, IconProps } from '../icon';

export type PropertiesPanelIconPropertyProps = {
    id: string;
    label: React.ReactNode;
    icon: React.ReactNode;
    onIconClick?: IconProps['onClick'];
    disabled?: boolean;
};
export const PropertiesPanelIconProperty: React.FC<PropertiesPanelIconPropertyProps> = ({ id, label, icon, onIconClick, disabled }) => {
    return (
        <PropertiesPanelProperty>
            <PropertiesPanelLabel htmlFor={`${id}-input`}>{label}</PropertiesPanelLabel>
            <PropertiesPanelControl>
                <Icon onClick={onIconClick} disabled={disabled} $hoverable>
                    {icon}
                </Icon>
            </PropertiesPanelControl>
        </PropertiesPanelProperty>
    );
};
